import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Button, TextField, useInput, Checkbox, TextArea } from '../../components';
import { Grid } from '@mui/material';
import { colors } from '../../assets/colors';
import { ReactComponent as Latte } from '../../assets/illustrations/Studio-Valerie-Maas-grafisch-ontwerp-illustraties_kopje-latte-macchiato.svg';
import { useDispatch } from 'react-redux';
import { postContactForm } from '../../actions/contactforms';

export default function ContactForm(props) {
    const hasPhone = props.hasPhone;
    const hasTablet = props.hasTablet;

    const { value: valueFirstName, bind: bindFirstName } = useInput('');
    const { value: valueLastName, bind: bindLastName } = useInput('');
    const { value: valueEmail, bind: bindEmail } = useInput('');
    const { value: valuePhone, bind: bindPhone } = useInput('');
    const { value: valueSubject, bind: bindSubject } = useInput('');
    const { value: valueCompanyName, bind: bindCompanyName } = useInput('');
    const { value: valueLink, bind: bindLink } = useInput('');
    const { value: valueHelp, bind: bindHelp } = useInput('');
    const { value: valueVerder, bind: bindVerder } = useInput('');
    const { value: valueMaand, bind: bindMaand } = useInput('');
    const { value: valueJaar, bind: bindJaar } = useInput('');
    const [ isBrandingChecked, setBrandingChecked ] = useState(false);
    const [ isWebsiteChecked, setWebsiteChecked ] = useState(false);
    const [ isLettertypeChecked, setLettertypeChecked ] = useState(false);
    const [ isAndersChecked, setAndersChecked ] = useState(false);
    const [ isTarievenChecked, setTarievenChecked ] = useState(false);

    let history = useHistory();
    const dispatch = useDispatch();

    const handleSubmit = (evt) => {
        evt.preventDefault();

        const formValues = {
            'first_name': valueFirstName,
            'last_name': valueLastName,
            'email': valueEmail,
            'phone': valuePhone,
            'subject': valueSubject,
            'company_name': valueCompanyName,
            'type': 'contactformulier',
            'link': valueLink,
            'wants_branding': isBrandingChecked,
            'wants_website': isWebsiteChecked,
            'wants_lettertype': isLettertypeChecked,
            'wants_anders': isAndersChecked,
            'help': valueHelp,
            'verder': valueVerder,
            'knows_tarieven': isTarievenChecked,
            'deadline_month': valueMaand,
            'deadline_year': valueJaar
        }

        dispatch(postContactForm(formValues)).then(history.push('/contact/bedankt'));
    }

    const pageWidth = hasPhone ? '60vw' : hasTablet ? '35vw' : '25vw';
    const textFieldStyle = { width: pageWidth, marginBottom: hasPhone ? '2vw' : hasTablet ? '1vw' : '0.5vw'};

    return (
        <form onSubmit={handleSubmit} autoComplete='on' style={{ margin: '5vw 0'}}>
            <div style={{ position: 'relative' }}>
                <Grid container direction='column' alignItems='center'>
                    <Typography variant='h1'>Contact</Typography>
                    <TextField 
                        placeholder='Voornaam'
                        style={textFieldStyle}
                        required
                        {...bindFirstName}
                    />
                    <TextField 
                        placeholder='Achternaam'
                        style={textFieldStyle}
                        required
                        {...bindLastName}
                    />
                    <TextField 
                        placeholder='E-mailadres'
                        id='email'
                        type='email'
                        style={textFieldStyle}
                        required
                        {...bindEmail}
                    />
                    <TextField 
                        placeholder='Telefoonnummer'
                        id='phone'
                        type='tel'
                        style={textFieldStyle}
                        required
                        {...bindPhone}
                    />
                    <TextField 
                        placeholder='Onderwerp'
                        style={textFieldStyle}
                        required
                        {...bindSubject}
                    />
                    <TextField 
                        placeholder='Bedrijfsnaam'
                        style={textFieldStyle}
                        {...bindCompanyName}
                    />
                    <Typography style={{ color: colors.title, width: pageWidth, display: 'inline', margin: hasPhone ? '2vw 0' : hasTablet ? '1vw 0' : '1vw 0 0.5vw 0'}}>
                        Deel een link waar ik een kijkje kan nemen bij jouw bedrijf. 
                        <span style={{ fontSize: hasPhone ? '11px' : hasTablet ? '12px' : '14px'}}> Je website of instagram-pagina.</span>
                    </Typography>
                    <TextField 
                        placeholder='Link'
                        style={textFieldStyle}
                        type='url'
                        {...bindLink}
                    />
                    <Typography style={{ color: colors.title, width: pageWidth, margin: hasPhone ? '2vw 0 1vw 0' : hasTablet ? '1vw 0 0.5vw 0' : '1vw 0 0 0'}}>
                        Waar ben je naar opzoek?
                    </Typography>
                    <div style={{ position: 'relative', width: pageWidth, height: hasPhone ? '25vw' : hasTablet ? '13vw' : '7vw', margin: hasPhone ? '1vw 0 5vw 0' : '0.5vw 0 1vw 0' }}>
                        <div style={{ position: 'absolute', left: hasPhone ? '-3vw' : hasTablet ? '-1.5vw' : '-0.5vw' }}>
                            <Checkbox
                                onClick={e => setBrandingChecked(!isBrandingChecked)}
                                isChecked={isBrandingChecked}
                            >
                                Branding
                            </Checkbox>
                            <Checkbox
                                onClick={e => setWebsiteChecked(!isWebsiteChecked)}
                                isChecked={isWebsiteChecked}
                            >
                                Website
                            </Checkbox>
                            <Checkbox
                                onClick={e => setLettertypeChecked(!isLettertypeChecked)}
                                isChecked={isLettertypeChecked}
                            >
                                Lettertype
                            </Checkbox>
                            <Checkbox
                                onClick={e => setAndersChecked(!isAndersChecked)}
                                isChecked={isAndersChecked}
                            >
                                Anders...
                            </Checkbox>
                        </div>
                    </div>
                    <TextArea 
                        placeholder='Vertel me waar ik je mee kan helpen'
                        rows={8}
                        style={textFieldStyle}
                        {...bindHelp}
                    />
                    <TextArea 
                        placeholder='Wil je verder nog iets vertellen?'
                        rows={8}
                        style={textFieldStyle}
                        {...bindVerder}
                    />
                    <Typography style={{ color: colors.title, width: pageWidth, margin: hasPhone ? '2vw 0 1vw 0' : '1vw 0 0 0'}}>
                        Ben je op de hoogte van mijn tarieven?
                    </Typography>
                    <div style={{ position: 'relative', width: pageWidth, height: '1.5vw', margin: hasPhone ? '1vw 0 5vw 0' : hasTablet ? '0.5vw 0 2vw 0' : '0.5vw 0 0 0'}} >
                        <div style={{ position: 'absolute', left: hasPhone ? '-3vw' : hasTablet ? '-1.5vw' : '-0.5vw' }}>
                            <Checkbox
                                    onClick={e => setTarievenChecked(!isTarievenChecked)}
                                    isChecked={isTarievenChecked}
                                >
                                    Zeker!
                            </Checkbox>
                        </div>
                    </div>
                    <Typography style={{ color: colors.title, width: pageWidth, margin: hasPhone ? '2vw 0' : hasTablet ? '1vw 0' : '1vw 0 0.5vw 0' }}>
                        Heb je een deadline voor jouw project?
                    </Typography>
                    <div style={{ position: 'relative', height: hasPhone ? '25vw' : hasTablet ? '11vw' : '5vw', width: pageWidth }}>
                        <div style={{ position: 'absolute', left: hasPhone ? '-3vw' : hasTablet ? '-1.5vw' : '-0.5vw', top: '0', display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', gap: hasPhone ? '2vw' : hasTablet ? '1vw' : '0vw', margin: '0 0 2vw 0'}}>
                            <TextField 
                                placeholder='Maand'
                                style={{ width: hasPhone ? '10vw' : '6vw'}}
                                {...bindMaand}
                            />
                            <TextField 
                                placeholder='Jaar'
                                style={{ width: '3vw' }}
                                {...bindJaar}
                            />
                        </div>
                    </div>
                    <Button type='submit' style={{ marginBottom: '10px'}}>Verstuur</Button>
                    <Button type='submit' onClick={(e) => window.open('https://calendly.com/valeriemaas/kennismaking')} style={{ width: pageWidth }}>Verstuur en plan meteen een gratis kennismakingsgesprek in</Button>
                </Grid>
                {!hasPhone && <Latte style={{ fill: colors.latte, position: 'absolute', left: '12vw', top: '20vw', width: hasTablet ? '7vw' : '5vw' }} />}
            </div>
        </form>
    )
}